<template>
  <div class="sport-container">
    <sport-header :sport="sport" />
    <match
      v-for="matchId in sport.matchIds"
      :key="matchId"
      :match-id="matchId"
    />
  </div>
</template>

<script>
import SportHeader from './SportHeader.vue';
import Match from './Match.vue';

export default {
  name: 'Sport',
  components: { SportHeader, Match },
  props: {
    sport: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.sport-container {
  float: left;
  width: 100%;
}

.sport-container /deep/ {
  .grid-left {
    position: relative;
    float: left;
    width: 38%;
    height: inherit;
    line-height: 5vh;
  }

  .grid-right {
    position: relative;
    float: left;
    width: 62%;
    height: inherit;
  }
}
</style>
